import React from 'react';
import type { FormBuilderBlockIconKey } from '../../forms/formBuilder/blockIconTypes';

const stroke = {
  fill: 'none' as const,
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

function Svg({ children, width = 14, height = 14, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" aria-hidden {...props}>
      {children}
    </svg>
  );
}

export function FbIconType(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Svg {...props}>
      <polyline points="4 7 4 4 20 4 20 7" {...stroke} />
      <line x1="9" y1="20" x2="15" y2="20" {...stroke} />
      <line x1="12" y1="4" x2="12" y2="20" {...stroke} />
    </Svg>
  );
}

export function FbIconAlignLeft(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Svg {...props}>
      <line x1="17" y1="10" x2="3" y2="10" {...stroke} />
      <line x1="21" y1="6" x2="3" y2="6" {...stroke} />
      <line x1="21" y1="14" x2="3" y2="14" {...stroke} />
      <line x1="17" y1="18" x2="3" y2="18" {...stroke} />
    </Svg>
  );
}

export function FbIconFileText(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Svg {...props}>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" {...stroke} />
      <polyline points="14 2 14 8 20 8" {...stroke} />
    </Svg>
  );
}

export function FbIconHash(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Svg {...props}>
      <line x1="4" y1="9" x2="20" y2="9" {...stroke} />
      <line x1="4" y1="15" x2="20" y2="15" {...stroke} />
      <line x1="10" y1="3" x2="8" y2="21" {...stroke} />
      <line x1="16" y1="3" x2="14" y2="21" {...stroke} />
    </Svg>
  );
}

export function FbIconChevronDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Svg {...props}>
      <rect x="3" y="6" width="18" height="14" rx="2" {...stroke} />
      <path d="M8 12l4 4 4-4" {...stroke} />
    </Svg>
  );
}

export function FbIconCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="9" {...stroke} />
    </Svg>
  );
}

export function FbIconCheckSquare(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Svg {...props}>
      <polyline points="9 11 12 14 22 4" {...stroke} />
      <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" {...stroke} />
    </Svg>
  );
}

export function FbIconCalendarIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Svg {...props}>
      <rect x="3" y="4" width="18" height="18" rx="2" {...stroke} />
      <line x1="16" y1="2" x2="16" y2="6" {...stroke} />
      <line x1="8" y1="2" x2="8" y2="6" {...stroke} />
      <line x1="3" y1="10" x2="21" y2="10" {...stroke} />
    </Svg>
  );
}

export function FbIconUpload(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Svg {...props}>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" {...stroke} />
      <polyline points="17 8 12 3 7 8" {...stroke} />
      <line x1="12" y1="3" x2="12" y2="15" {...stroke} />
    </Svg>
  );
}

export function FbIconPenTool(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Svg {...props}>
      <path d="m12 19 7-7 3 3-7 7-3-3z" {...stroke} />
      <path d="m18 13-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" {...stroke} />
      <circle cx="11" cy="11" r="2" {...stroke} />
    </Svg>
  );
}

export function FbIconMinus(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Svg {...props}>
      <path d="M5 12h14" {...stroke} />
    </Svg>
  );
}

export function FbIconMapPin(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Svg {...props}>
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" {...stroke} />
      <circle cx="12" cy="10" r="3" {...stroke} />
    </Svg>
  );
}

export function FbIconLock(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Svg {...props}>
      <rect width="14" height="11" x="5" y="11" rx="2" {...stroke} />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" {...stroke} />
    </Svg>
  );
}

export function FbIconUser(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Svg {...props}>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" {...stroke} />
      <circle cx="12" cy="7" r="4" {...stroke} />
    </Svg>
  );
}

export function FbIconHeart(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Svg {...props}>
      <path
        d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
        {...stroke}
      />
    </Svg>
  );
}

export function FbIconCreditCard(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Svg {...props}>
      <rect x="2" y="5" width="20" height="14" rx="2" {...stroke} />
      <line x1="2" y1="10" x2="22" y2="10" {...stroke} />
    </Svg>
  );
}

export function FbIconShieldOutline(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Svg {...props}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" {...stroke} />
    </Svg>
  );
}

const ICON_COMPONENTS: Record<FormBuilderBlockIconKey, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  Type: FbIconType,
  AlignLeft: FbIconAlignLeft,
  FileText: FbIconFileText,
  Hash: FbIconHash,
  ChevronDown: FbIconChevronDown,
  Circle: FbIconCircle,
  CheckSquare: FbIconCheckSquare,
  CalendarIcon: FbIconCalendarIcon,
  Upload: FbIconUpload,
  PenTool: FbIconPenTool,
  Minus: FbIconMinus,
  MapPin: FbIconMapPin,
  Lock: FbIconLock,
  User: FbIconUser,
  Heart: FbIconHeart,
  CreditCard: FbIconCreditCard,
  ShieldOutline: FbIconShieldOutline,
};

export function FormBuilderBlockIcon({
  icon,
  size = 14,
  className,
}: {
  icon: FormBuilderBlockIconKey;
  size?: number;
  className?: string;
}) {
  const C = ICON_COMPONENTS[icon];
  return <C width={size} height={size} className={className} />;
}
